/**
 * Lightweight wrapper around Firebase Analytics for SPA route tracking and
 * custom events. All calls are no-ops if Analytics is not initialised (e.g.
 * placeholder measurementId, unsupported browser, SSR/build-time).
 */
import { logEvent as fbLogEvent } from "firebase/analytics";
import { getAnalyticsSafe } from "./firebase";

export async function logPageView(path: string, title?: string): Promise<void> {
  const analytics = await getAnalyticsSafe();
  if (!analytics) return;
  fbLogEvent(analytics, "page_view", {
    page_path: path,
    page_location: typeof window !== "undefined" ? window.location.href : path,
    page_title: title ?? (typeof document !== "undefined" ? document.title : undefined),
  });
}

export async function logAnalyticsEvent(
  name: string,
  params?: Record<string, unknown>,
): Promise<void> {
  const analytics = await getAnalyticsSafe();
  if (!analytics) return;
  fbLogEvent(analytics, name, params);
}
